<!-- 课程管理模块 -->
<template>
    <!-- 刷卡记录表 -->
    <div class="buttonlist">
        <div class="buttonlist-m">
            <div v-loading="loading" element-loading-text="拼命加载中......">
                <el-table :data="tableData" style="width: 100%" :row-style="tableRowStyle"
                    :header-cell-style="tableHeaderColor">
                    <el-table-column prop="typeName" :width="180" label="场景名称" align=center></el-table-column>
                    <el-table-column prop="typeName" label="场景描述" :formatter="showDesc"
                        align=left></el-table-column>
                    <el-table-column prop="count" :width="100" label="个数" align=center></el-table-column>
                </el-table>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            pageNum: 1, //页码
            pageSize: 10, //每页显示的条数
            totalDataNumber: 0,
            loading: true,
            tableData: [],
            typeList: [],
            addForm: {},
        };
    },
    methods: {
        showDesc(row) {
            if (row.typeCode == 1) {
                return '通过血糖、血压、血氧等检测设备对老人身体开展生命体征检测，线上医生给予医疗建议;开展慢性病管理和随访，助医、陪医等服务;利用智能药箱、机器人等实现按时服药和提醒等。';
            } else if (row.typeCode == 2) {
                return '利用监控、红外、传感、门磁等设备形成监管手段，保障老人人身安全。';
            } else if (row.typeCode == 3) {
                return '通过一键呼、手表、对讲等外呼设备实行一键呼叫响应机制随时应答老人需求。';
            } else if (row.typeCode == 4) {
                return '通过陪护机器人、孝心眼、自动电话关爱等设备，或专业心理咨询师、志愿者、社会工作者辅助手段，陪同老人聊天、开展心理捕导等服务。';
            } else if (row.typeCode == 5) {
                return '借助多功能护理床、康复器械等设备获取老人生命体征和日常活动数据，开展康复护理计划。';
            } else if (row.typeCode == 6) {
                return '利用各种智能化设备(比如防抖勺、智能床、智能马桶等)开展助餐、助洁、远程照护等生活照料服务。';
            } else if (row.typeCode == 7) {
                return '通过移动辅具实现老人辅助行走。';
            } else if (row.typeCode == 8) {
                return '通过线上教育课程、组织智能化培训、娱乐机器人等智能设备满足老人休闲娱乐需求。';
            }
        },
        tableRowStyle({ row, rowIndex }) {
            if (rowIndex % 2 == 0) {
                return "background-color: #ffffff";
            } else {
                return "background-color: #e4f5f8";
            }
        },
        tableHeaderColor({ row, column, rowIndex, columnIndex }) {
            if (rowIndex === 0) {
                return "color:#2d2d2d;font-weight: 600; text-align: center;font-size: 16px;background-color: #d4f5fa;";
            }
        },
        //获取分页的紧急按钮数据  只获取pageSize条数据
        getTableData() {
            this.loading = true;
            this.$postJson('dmc/device/showScene').then(res => {
                if (res.code == 200) {
                    this.tableData = res.result;
                }
                this.loading = false;
            })
        },

    },
    mounted() {
        this.getTableData();
    },
    created() {
        this.groupId = sessionStorage.getItem("groupId");
    },
};
</script>
<style lang="scss" scoped>
.buttonlist {
    .buttonlist-m {
        padding: 10px 0 0 5px;
    }
}

.fenye {
    margin: 0;
    padding: 30px 0;
    background: #fff;
}
</style>
